import { Tooltip } from "@mui/material";
import React, { useState } from "react";

//icons /:|
import {
  AiOutlineArrowDown,
  AiOutlineArrowUp,
  AiOutlineDelete,
  AiOutlineFileAdd,
} from "react-icons/ai";

import {
  BiCheckboxSquare,
  BiRadioCircleMarked,
  BiStar,
  BiText,
} from "react-icons/bi";

export default function SurveyItems({
  ref,
  index,
  children,
  OnClick,
  DeleteQuestions,
  MoveQuestionsUp,
  MoveQuestionsDown,
  SurveyAddItem,
  surveyLenght,
  onEdit = false,
}) {
  const [visiblty, setvisiblty] = useState(false);
  const [addquestions, setaddquestions] = useState(false);

  function AddItem(value) {
    setaddquestions(true);
    SurveyAddItem(value);
  }
  return (
    <>
      <div
        ref={ref}
        className="flex transition-all flex-col md:flex-row"
        onMouseOver={() => !onEdit && setvisiblty(true)}
        onMouseLeave={() =>
          !onEdit && (setvisiblty(false), setaddquestions(false))
        }
      >
        <div
          onClick={() => OnClick()}
          style={visiblty ? { borderLeft: 10 } : {}}
          className={
            !visiblty
              ? "p-10 bg-white flex flex-col items-start m-4 rounded-2xl lg:w-[1100px]  md:w-[800px]    transition-all border-2"
              : "p-10 bg-white flex flex-col items-start m-4 rounded-2xl lg:w-[1100px]  md:w-[800px]    transition-all  border-4 "
          }
        >
          <div className="m-1  bg-white ">{children}</div>
        </div>

        <div
          className={
            visiblty
              ? "  md:w-16  md:my-4 my-0 mx-4 md:mx-1 bg-white rounded-2xl  transition-all duration-500 border-2 flex flex-row md:flex-col items-center justify-center"
              : "w-0 h-0 md:h-auto opacity-0  transition-all  items-center justify-center duration-500 flex flex-row md:flex-col"
          }
        >
          {index === 0 ? (
            <Tooltip placement="right" title="Soruyu yukarı taşı">
              <div className=" rounded-full opacity-25 cursor-not-allowed  bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 ">
                <AiOutlineArrowUp size={25} />
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="right" title="Soruyu yukarı taşı">
              <div
                onClick={(e) => MoveQuestionsUp()}
                className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
              >
                <AiOutlineArrowUp size={25} />
              </div>
            </Tooltip>
          )}

          <Tooltip placement="right" title="Soruyu Sil">
            <div
              onClick={(e) => DeleteQuestions()}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <AiOutlineDelete size={25} />
            </div>
          </Tooltip>

          <Tooltip placement="right" title="Yeni soru ekle">
            <div
              onClick={(e) => AddItem()}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <AiOutlineFileAdd size={25} />
            </div>
          </Tooltip>

          {surveyLenght - 1 === index ? (
            <Tooltip placement="right" title="Soruyu aşağı taşı">
              <div className=" rounded-full opacity-50 bg-gray-200 p-2 cursor-not-allowed my-2 md:mx-0 mx-2  hover:bg-gray-300 ">
                <AiOutlineArrowDown size={25} />
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="right" title="Soruyu aşağı taşı">
              <div
                onClick={(e) => MoveQuestionsDown()}
                className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
              >
                <AiOutlineArrowDown size={25} />
              </div>
            </Tooltip>
          )}
        </div>

        <div
          className={
            addquestions && visiblty
              ? " mb-6 mt-2  md:w-16  md:my-4 my-0 mx-4 md:mx-1 bg-white rounded-2xl  transition-all duration-500 border-2 flex flex-row md:flex-col items-center justify-center"
              : "invisible relative w-0 opacity-0 h-0 md:h-auto  transition-all  items-center justify-center duration-500 flex flex-row md:flex-col"
          }
        >
          <Tooltip placement="right" title="Birden fazla seçmeli">
            <div
              onClick={(e) => AddItem("multi")}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <BiCheckboxSquare size={25} />
            </div>
          </Tooltip>
          <Tooltip placement="right" title="Çoktan seçmeli">
            <div
              onClick={(e) => AddItem("single")}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <BiRadioCircleMarked size={25} />
            </div>
          </Tooltip>
          <Tooltip placement="right" title="Metin eklemeli">
            <div
              onClick={(e) => AddItem("input")}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <BiText size={25} />
            </div>
          </Tooltip>
          <Tooltip placement="right" title="Puanlamalı">
            <div
              onClick={(e) => AddItem("score")}
              className=" rounded-full bg-gray-200 p-2 my-2 md:mx-0 mx-2  hover:bg-gray-300 cursor-pointer"
            >
              <BiStar size={25} />
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  );
}
